import type { DetailedGmv } from '../store-trajectory-values'
import { type ReactNode, useContext } from 'react'
import { useFormatNumber } from 'core/hooks/useFormatNumber'
import { useFormatAmount } from 'core/hooks/useFormatAmount'
import RecapGvmValue from './recap-gvm-value'
import { StoreTrajectoryContext } from '../../state/store-trajectory-context'
import { useTranslation } from 'react-i18next'

interface RecapGmvCardProps {
  detailedGmv: DetailedGmv
  title: ReactNode
  isOmni: boolean
}

const RecapGmvCard = ({ detailedGmv, title, isOmni }: RecapGmvCardProps) => {
  const { t } = useTranslation()
  const { store } = useContext(StoreTrajectoryContext)
  const formatAmount = useFormatAmount()
  const formatNumber = useFormatNumber()

  return (
    <div
      className={
        'mg-store-trajectory-recap-gmv-card' + (isOmni ? '' : ' mg-store-trajectory-recap-gmv-card-background')
      }
    >
      <div className="mg-store-trajectory-recap-gmv-card-title" data-testid="recap-gmv-card-title">
        {title}
      </div>
      <div className="mg-store-trajectory-recap-gmv-card-body">
        <RecapGvmValue
          label={isOmni ? t('general.trajectory.store.recap.total-gmv') : t('general.trajectory.store.recap.gmv')}
          formatedValue={formatAmount(detailedGmv?.gmv?.value, store.currency)}
          progression={detailedGmv?.gmv?.progression}
          isOmni={isOmni}
        />
        <RecapGvmValue
          label={t('general.trajectory.store.recap.margin-rate')}
          formatedValue={formatNumber(detailedGmv?.marginRate?.value, '--', {
            minimumFractionDigits: 1,
            maximumFractionDigits: 1,
            signDisplay: 'always',
            style: 'percent'
          })}
          progression={detailedGmv?.marginRate?.progression}
          isOmni={isOmni}
        />
        <RecapGvmValue
          label={t('general.trajectory.store.recap.selling-price')}
          formatedValue={formatAmount(detailedGmv?.sellingPrice?.value, store.currency)}
          progression={detailedGmv?.sellingPrice?.progression}
          isOmni={isOmni}
        />
        <RecapGvmValue
          label={t('general.trajectory.store.recap.quantity')}
          formatedValue={formatNumber(detailedGmv?.quantity?.value)}
          progression={detailedGmv?.quantity?.progression}
          isOmni={isOmni}
        />
      </div>
    </div>
  )
}

export default RecapGmvCard
